import React, { createContext, useContext, useState } from 'react'
import ModalCr from '../commons/Modal/ModalCe';

interface ModalContextProps {
    modalOpen: boolean,
    showModal: (props: ModalProps) => void,
    closeModal: () => void,
}

export interface ModalProps {
    titleModal: string;
    textModal: string;
    primaryBtn: boolean;
    secondaryBtn: boolean;
    textPrimaryBtn?: string;
    textSecondatyBtn?: string;
    onClickPrimaryBtn?: (event:any) => void;
    OnClickSecondaryBtn?: (event:any) => void;
}

interface ModalProviderProps {
    children: React.ReactNode;
}

const ModalContext = createContext<ModalContextProps | undefined>(undefined); 

export const ModalProvider: React.FC<ModalProviderProps> = ({children})=> {
    const [modalOpen, setModalOpen] = useState(false);
    const [modalProps, setModalProps] = useState<ModalProps|undefined>(undefined);

    const showModal = (props: ModalProps)=> {
        document.body.style.overflow = "hidden";
        setModalOpen(true);
        setModalProps(props);
    }
    const closeModal = () => {
        document.body.style.overflow="visible";
        setModalOpen(false);
        setModalProps(undefined);
    }

    return (
        <ModalContext.Provider value={{modalOpen, showModal, closeModal}}>
            {children}
            {modalOpen && modalProps && (
                <ModalCr
                    titleModal={modalProps.titleModal}
                    textModal={modalProps.textModal}
                    primaryBtn={modalProps.primaryBtn}
                    secondaryBtn={modalProps.secondaryBtn}
                    textPrimaryBtn={modalProps.textPrimaryBtn}
                    textSecondatyBtn={modalProps.textSecondatyBtn}
                    onClickPrimaryBtn={modalProps.onClickPrimaryBtn}
                    OnClickSecondaryBtn={modalProps.OnClickSecondaryBtn}
                />
            )}
        </ModalContext.Provider>
    );
}

export const useModal = (): ModalContextProps => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
}